import React from 'react';
import { Page } from 'src/Common/Components/Page';
import { AllBlueprintsManagementContent } from './Components/AllBlueprintsManagementContent';

export const AllBlueprintsManagement = (): React.JSX.Element => (
  <Page title="Blueprints" accessKey={'blueprints'} isSearchable={true}>
    <AllBlueprintsManagementContent />
  </Page>
);
